<div class="drawer" data-id="drawer" aria-hidden="true">

  <div class="drawer__scrim" data-id="scrim"></div>

  <aside class="drawer__panel" role="dialog" aria-modal="true" aria-label="<%= _lcs( 'Menü' ) %>">

    <header class="drawer__head">
      <div class="drawer__head-row">
        <span class="drawer__mark<%= logoUrl ? ' drawer__mark--logo' : '' %>">
          <% if ( logoUrl ) { %>
          <img class="drawer__mark-logo" src="<%= logoUrl %>" alt="<%= house %>" />
          <% } else { %>
          <svg width="28" height="28" viewBox="0 0 120 120" fill="none" aria-hidden="true">
            <defs><clipPath id="dwFrame"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath></defs>
            <rect x="26" y="18" width="68" height="84" rx="18" stroke="#F2E9DC" stroke-width="4.5"></rect>
            <g clip-path="url(#dwFrame)">
              <circle cx="46.5" cy="44" r="8.5" stroke="#D6C59D" stroke-width="3.6"></circle>
              <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#F2E9DC" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            </g>
          </svg>
          <% } %>
        </span>
        <button class="drawer__close iconbtn" type="button" data-id="close" aria-label="<%= _lcs( 'Menü schließen' ) %>">
          <i class="icon icon--x"></i>
        </button>
      </div>
      <div class="drawer__house"><%= house %></div>
      <div class="drawer__guest"><%= guestLine %></div>
    </header>

    <div class="drawer__body">
      <% groups.forEach( function( g ) { %>
        <div class="drawer__group">
          <div class="drawer__group-title"><%= _lcs( g.title ) %></div>
          <% g.items.forEach( function( it ) { %>
            <% if ( it.id === 'language' ) { %>
              <!-- The one item that answers in place rather than navigating:
                   picking a language reloads the app, so a screen to leave and
                   come back from would be a screen nobody sees. -->
              <button class="drawer__item" type="button" data-id="lang-toggle"
                      aria-expanded="false" aria-controls="drawer-langs">
                <i class="icon icon--<%= it.icon %> drawer__item-icon"></i>
                <span class="drawer__item-label"><%= _lcs( it.label ) %></span>
                <span class="drawer__item-meta"><%= currentLanguageLabel %></span>
                <i class="icon icon--chevron-down drawer__item-chev"></i>
              </button>
              <div class="drawer__langs" id="drawer-langs" data-id="langs" hidden>
                <% languages.forEach( function( lang ) { %>
                  <button class="drawer__lang<%= lang.code === currentLanguage ? ' drawer__lang--active' : '' %>"
                          type="button" data-id="lang" data-lang="<%= lang.code %>"
                          role="menuitemradio" aria-checked="<%= lang.code === currentLanguage ? 'true' : 'false' %>">
                    <span><%= lang.label %></span>
                    <% if ( lang.code === currentLanguage ) { %><i class="icon icon--check"></i><% } %>
                  </button>
                <% } ); %>
              </div>
            <% } else if ( it.id === 'house' ) { %>
              <% if ( houses.length > 1 ) { %>
              <!-- Like the languages: answers in place. Picking a house opens
                   that house's guest-app, still signed in. -->
              <button class="drawer__item" type="button" data-id="house-toggle"
                      aria-expanded="false" aria-controls="drawer-houses">
                <i class="icon icon--<%= it.icon %> drawer__item-icon"></i>
                <span class="drawer__item-label"><%= _lcs( it.label ) %></span>
                <span class="drawer__item-meta"><%= house %></span>
                <i class="icon icon--chevron-down drawer__item-chev"></i>
              </button>
              <div class="drawer__langs" id="drawer-houses" data-id="houses" hidden>
                <% houses.forEach( function( h ) { %>
                  <button class="drawer__lang<%= h.id === currentHouseId ? ' drawer__lang--active' : '' %>"
                          type="button" data-id="house" data-accommodation-id="<%= h.id %>"
                          role="menuitemradio" aria-checked="<%= h.id === currentHouseId ? 'true' : 'false' %>">
                    <span><%= h.name %></span>
                    <% if ( h.id === currentHouseId ) { %><i class="icon icon--check"></i><% } %>
                  </button>
                <% } ); %>
              </div>
              <% } %>
            <% } else if ( it.url ) { %>
              <a class="drawer__item" href="<%= it.url %>" target="_blank" rel="noopener" data-id="external">
                <i class="icon icon--<%= it.icon %> drawer__item-icon"></i>
                <span class="drawer__item-label"><%= _lcs( it.label ) %></span>
                <i class="icon icon--chevron-right drawer__item-chev"></i>
              </a>
            <% } else { %>
              <button class="drawer__item" type="button"
                      data-route="<%= it.route || '' %>" data-label="<%= _lcs( it.label ) %>">
                <i class="icon icon--<%= it.icon %> drawer__item-icon"></i>
                <span class="drawer__item-label"><%= _lcs( it.label ) %></span>
                <% if ( it.meta ) { %><span class="drawer__item-meta"><%= _lcs( it.meta ) %></span><% } %>
                <i class="icon icon--chevron-right drawer__item-chev"></i>
              </button>
            <% } %>
          <% } ); %>
        </div>
      <% } ); %>

      <!-- Install the app: only while it is not installed and can be (core/Pwa).
           A card rather than a list row, so it is not lost among the items. -->
      <button class="drawer__install" type="button" data-id="install"<%= canInstall ? '' : ' hidden' %>>
        <span class="drawer__install-icon"><i class="icon icon--download"></i></span>
        <span class="drawer__install-text">
          <span class="drawer__install-title"><%= _lcs( 'App installieren' ) %></span>
          <span class="drawer__install-sub"><%= _lcs( 'Als App auf den Home-Bildschirm — auch offline nutzbar.' ) %></span>
        </span>
        <i class="icon icon--chevron-right drawer__install-chev"></i>
      </button>
    </div>

    <footer class="drawer__foot">
      <button class="drawer__logout" type="button" data-id="logout">
        <i class="icon icon--log-out"></i> <%= _lcs( 'Abmelden' ) %>
      </button>
    </footer>

  </aside>
</div>
